import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

import { NumberSeparatorPipe } from 'src/app/core/pipes/number.separator.pipe';
import { SmartSmsService } from '../../../core/api/services';
import { BaseChipListSelectSearch } from './base/base-chip-list-select-search.component';
import { BaseChipListSelectSearchModule } from './base/base-chip-list-select.search.module';

@Component({
    selector: 'provinces-chip-list-select-search',
    templateUrl: './base/base-chip-list-select-search-template.html',
    imports: [BaseChipListSelectSearchModule]
})
export class ProvincesChipListSelectSearchComponent
  extends BaseChipListSelectSearch
  implements OnInit
{
  constructor(
    protected currentService: SmartSmsService,
    protected numberSeparatorPipe: NumberSeparatorPipe
  ) {
    super();
  }

  initConfig() {
    super.initConfig();
    if (!this.label) this.label = 'common.state';
  }

  getItemsApi() {
    this.currentService
      .smartSmsGetProvinces()
      .pipe(
        this.basePipeOperators(),
        map((items) => {
          return items.data.map((item) => {
            return {
              ...item,
              optionTitle: `${item.name}`,
            };
          });
        })
      )
      .subscribe(this.baseObserver);
  }
}
